<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import axios from "axios";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Results Reviewing Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      search_status: false,
      filterdArray: [],
      advancedsearch: {
        search: "",
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
      },
      title: "Laboratory Results Reviewing",
      items: [
        {
          text: "Laboratory Section",
          href: "#",
        },
        {
          text: "Results Pending Review",
          active: true,
        },
      ],
      flagOptions: [
        { value: "Low", label: "Lower" },
        { value: "Normal", label: "Normal" },
        { value: "High", label: "Higher" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000,10000,100000,1000000,10000000,100000000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
          {
              key: "patientCode",
              sortable: true,
              label: "PATIENT No.",
          },
        {
          key: "patientName",
          sortable: true,
          label: "PATIENT NAME",
        },
        // {
        //   key: "branch.name",
        //   sortable: true,
        //   label: "BRANCH",
        // },
        {
          key: "labrequest",
          sortable: false,
          label: "TEST DONE",
        },
      ],
      microResult: {
        testName: "",
        orderId: "",
      },
      definedResult: {
        testName: "",
        orderId: "",
        result: "",
        comment: "",
        other_options: "",
      },
      undefinedResult: {
        testName: "",
        orderId: "",
        comment: "",
      },
      parameterResult: {
        testName: "",
        orderId: "",
        comment: "",
        parameters: "",
      },
      model_id: "",
      resultIdError: "",
      commentError: "",
      noParameterFound: "",
      dataRequired: "",
    };
  },

  computed: {
    ...mapGetters("laboratory", [
      "pending_review",
      "ResultSuggestions",
      "ResultReviewStatus",
    ]),
    ...mapGetters("staffModule", ["clinic_staff"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    /**
     * Total no. of records
     */
    rows() {
      return this.filterdArray ? this.filterdArray.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filterdArray ? this.filterdArray.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
    pending_review(newVal) {
      if (newVal) {
        this.AssignTest();
      }
    },
  },
  methods: {
    //========= REVIEW DEFINED RESULTS ===============
    definedModal(test) {
      this.definedResult.testName = test.test.name;
      this.definedResult.orderId = test.id;
      this.definedResult.result = "";
      this.definedResult.comment = "";
      this.definedResult.other_options = "";
      // this.DefinedToReview(test.id);
      axios.get("defined_lab_test_to_review/" + test.id).then((res) => {
        this.definedResult.result = res.data.result;
        this.definedResult.comment = res.data.comment;
        this.definedResult.other_options = res.data.other_options;
      });
    },

    SearchTest() {
      this.search_status = true;
      axios
        .post("filter_pending_review", this.advancedsearch)
        .then((response) => {
          this.search_status = false;
          this.filterdArray = response.data.data;
        })
        .catch(() => {
          this.search_status = false;
        });
    },
    AssignTest() {
      this.filterdArray = this.pending_review;
    },
    confirmDefined(modalId) {
      this.model_id = modalId;

      // Exit when the form isn't valid
      if (this.definedResult.result === "") {
        this.resultIdError = "Result field is required";
        return;
      } else {
        this.resultIdError = "";
      }
      // Push the name to submitted names
      this.ReviewDefinedResult(this.definedResult);
    },

    resetDefinedModal() {
      this.definedResult.testName = "";
      this.definedResult.orderId = "";
      this.definedResult.result = "";
      this.definedResult.comment = "";
      this.definedResult.other_options = "";
      this.resultIdError = "";
    },

    //========= REVIEW UNDEFINED RESULTS ===============
    undefinedModal(test) {
      this.undefinedResult.testName = test.test.name;
      this.undefinedResult.orderId = test.id;
      this.undefinedResult.comment = test.description;
    },

    confirmUndefined(modalId) {
      this.model_id = modalId;

      // Exit when the form isn't valid
      if (this.undefinedResult.comment === "") {
        this.commentError = "Result Comment field is required";
        return;
      } else {
        this.commentError = "";
      }
      // Push the name to submitted names
      this.ReviewUndefinedResult(this.undefinedResult);
    },

    resetUndefined() {
      this.undefinedResult.testName = "";
      this.undefinedResult.orderId = "";
      this.undefinedResult.comment = "";
      this.commentError = "";
    },

    //========= REVIEW PARAMETER RESULTS ===============
    parameterModal(test) {
      this.parameterResult.testName = test.test.name;
      this.parameterResult.orderId = test.id;
      this.parameterResult.comment = "";
      this.parameterResult.parameters = "";

      axios.get("parameter_lab_test_to_review/" + test.id).then((res) => {
        this.parameterResult.comment = res.data.comment;
        this.parameterResult.parameters = res.data.parameters;
      });
    },

    confirmPara(modalId) {
      this.model_id = modalId;

      //Check if there are parameters for match this patient
      if (this.parameterResult.parameters.length < 1) {
        this.noParameterFound =
          "Sorry! You can not proceed past here, because there are no results to save";
        return;
      }
      //Check if empty submission
      if (
        this.parameterResult.parameters[0].result_value === "" &&
        this.parameterResult.parameters[1].result_value === ""
      ) {
        this.dataRequired =
          "At least " +
          this.parameterResult.parameters[0].parameterName +
          " or " +
          this.parameterResult.parameters[1].parameterName +
          " results are required to proceed";
        return;
      }
      // Push the name to submitted names
      this.ReviewParaResult(this.parameterResult);
    },

    resetParaModal() {
      this.parameterResult.testName = "";
      this.parameterResult.orderId = "";
      this.parameterResult.comment = "";
      this.parameterResult.parameters = "";
    },

    // ======== REVIEW MICROBIOLOGY RESULTS =========
    reviewMicrobiology(test) {
      this.microResult.testName = test.test.name;
      this.microResult.orderId = test.id;
    },

    resetMicrobioModal() {
      this.microResult.testName = "";
      this.microResult.orderId = "";
    },
    //== CLOSE ===========

    resetResultIdError() {
      this.resultIdError = "";
    },
    resetCommentError() {
      this.commentError = "";
    },
    resetMsg() {
      this.noParameterFound = "";
      this.dataRequired = "";
    },
    // CLOSE MODEL
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },

    ...mapActions({
      FetchPendingReview: "laboratory/fetchPendingReview",
      FetchSuggestions: "laboratory/fetchSuggestions",
      ReviewDefinedResult: "laboratory/definedResultReview",
      ReviewUndefinedResult: "laboratory/undefinedResultReview",
      ReviewParaResult: "laboratory/paraResultReview",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.FetchPendingReview();
    this.AssignTest();
    this.FetchSuggestions();
  },
};
</script>

<style scoped>
.loader-line {
  width: 200px;
  height: 3px;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
  margin: 20px auto;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}
.loader-line:before {
  content: "";
  position: absolute;
  left: -50%;
  height: 3px;
  width: 40%;
  background-color: rgb(0, 4, 255);
  -webkit-animation: lineAnim 1s linear infinite;
  -moz-animation: lineAnim 1s linear infinite;
  animation: lineAnim 1s linear infinite;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

@keyframes lineAnim {
  0% {
    left: -40%;
  }
  50% {
    left: 20%;
    width: 80%;
  }
  100% {
    left: 100%;
    width: 100%;
  }
}
</style>


<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <lable for="date1">Filter Start Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date1"
                  class="form-control"
                />
              </div>
              <div class="col-md-3">
                <lable for="date2">Filter End Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date2"
                  class="form-control"
                />
              </div>
              <div class="col-md-3">
                <lable>Name/Code/Contact</lable>
                <input
                  type="text"
                  v-model="advancedsearch.search"
                  class="form-control"
                  placeholder="Search name,code or contact"
                />
              </div>

              <div class="col-md-3">
                <br />
                <button v-if="search_status" disabled class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
                <button v-else @click="SearchTest()" class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div v-if="search_status" class="loader-line"></div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                bordered
                class="datatables"
                :items="filterdArray"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                  <template #cell(patientCode)="data">
                      {{ data.item.patient.patientCode }}
                  </template>
                <template #cell(patientName)="data">
                  {{ data.item.patient.patientName }} ({{ data.item.patient.age }})
                  <span
                    class="badge rounded-pill bg-success"
                    v-if="data.item.pay_status == 'Cleared'"
                    >Cleared</span
                  >
                  <span
                    class="badge rounded-pill bg-primary"
                    v-else-if="data.item.pay_status == 'insured'"
                    >Insured</span
                  >
                  <span class="badge rounded-pill bg-danger" v-else>
                    Not Cleared</span
                  >
                </template>
                <template #cell(labrequest)="data">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Test Name</th>
                        <th>Date and Time</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(test, t) in data.item.completetests" :key="t">
                        <td>
                          <span v-if="test.spouse">
                            <div style="color: green">
                              {{ test.test.name }}
                              <sup v-show="test.spouse" class="badge bg-success"
                                >Spouse</sup
                              >
                            </div>
                          </span>
                          <span v-else>
                            {{ test.test.name }}
                          </span>
                        </td>
                        <td>{{ test.dateCreated }}</td>
                        <td>
                          <span
                            v-if="
                              user_permissions
                                ? user_permissions.review_results
                                : false
                            "
                          >
                            <!-- Review Defined Results -->
                            <b-button
                              size="sm"
                              variant="primary"
                              v-b-modal.defined-modal
                              v-if="test.test.result_type == 1"
                              @click="definedModal(test)"
                              ><i class="fa fa-eye"></i> Review</b-button
                            >
                            <!-- Review Undefined Results -->
                            <b-button
                              size="sm"
                              variant="primary"
                              v-b-modal.undefined-modal
                              @click="undefinedModal(test)"
                              v-if="test.test.result_type == 2"
                            >
                              <i class="fa fa-eye"></i> Review</b-button
                            >
                            <!-- Review Machine Results -->
                            <b-button
                              size="sm"
                              variant="primary"
                              v-b-modal.machine-modal
                              @click="machineModal(test)"
                              v-if="test.test.result_type == 3"
                              ><i class="fa fa-eye"></i> Review</b-button
                            >
                            <!-- Review Parameter based Results -->
                            <b-button
                              size="sm"
                              variant="primary"
                              v-b-modal.parameter-modal
                              @click="parameterModal(test)"
                              v-if="test.test.result_type == 4"
                              ><i class="fa fa-eye"></i> Review</b-button
                            >
                            <!-- Review Microbiology Results -->
                            <router-link
                              v-if="test.test.result_type == 5"
                              :to="{
                                name: 'MicrobiologyReview',
                                params: {
                                  orderId: test.id,
                                  serviceId: test.test.id,
                                  visitId: test.visit,
                                },
                              }"
                            >
                              <button class="btn btn-primary btn-sm">
                                <i class="fa fa-eye"></i> Review
                              </button>
                            </router-link>
                          </span>
                          <span v-else>
                            <button
                              class="btn btn-sm btn-outline-secondary"
                              title="You are restricted"
                            >
                              <i class="fa fa-ban"></i> Review Results
                            </button>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>
              <div style="text-align: center">
                <h3 v-if="!pending_review" class="text-primary">
                  <b-spinner
                    class="m-0"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- ============================ -->
          <b-modal
            id="defined-modal"
            ref="modal"
            hide-footer
            @hidden="resetDefinedModal"
          >
            <template #modal-title>
              <p class="text-uppercase">
                {{ definedResult.testName }} result reviewing.
              </p>
            </template>
            <div v-if="definedResult.result">
              <div class="mb-3">
                <label class="col-form-label">Select Result:</label>
                <select
                  class="form-control"
                  v-model="definedResult.result.result_id"
                >
                  <option selected :value="definedResult.result.result_id">
                    {{ definedResult.result.result_name }}
                  </option>
                  <option
                    v-for="(option, r) in this.definedResult.other_options"
                    :key="r"
                    :value="option.id"
                  >
                    {{ option.result_name }}
                  </option>
                </select>
                <div class="text-danger" v-if="resultIdError">
                  <em>{{ resultIdError }}</em>
                </div>
              </div>
              <div class="mb-3">
                <label class="col-form-label">Result Comment:</label>
                <b-form-textarea
                  id="textarea-rows"
                  v-model="definedResult.comment"
                  @input="resetCommentError"
                  placeholder="Enter Result comments or result narration"
                  rows="8"
                ></b-form-textarea>
                <div class="text-danger">
                  <em>{{ commentError }}</em>
                </div>
              </div>
            </div>
            <div class="text-center" v-else>
              <b-spinner
                variant="primary"
                style="width: 3rem; height: 3rem"
                label="Large Spinner"
              ></b-spinner>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                @click="closeMode('defined-modal')"
                class="btn btn-secondary"
              >
                Close
              </button>
              <button
                type="button"
                @click="confirmDefined('defined-modal')"
                class="btn btn-success"
              >
                Save result
                <b-spinner
                  v-if="ResultReviewStatus"
                  variant="light"
                  small
                  role="status"
                ></b-spinner>
              </button>
            </div>
          </b-modal>

          <!-- ============================ -->
          <b-modal id="undefined-modal" @hidden="resetUndefined" hide-footer>
            <template #modal-title>
              <p class="text-uppercase">
                {{ undefinedResult.testName }} result entry
              </p>
            </template>
            <div class="mb-3">
              <label class="col-form-label">Result Comment:</label>
              <b-form-textarea
                id="textarea-rows"
                v-model="undefinedResult.comment"
                @input="resetCommentError"
                placeholder="Enter Result or result narration"
                rows="8"
              ></b-form-textarea>
              <div class="text-danger">
                <em>{{ commentError }}</em>
              </div>
            </div>

            <div class="modal-footer">
              <button
                class="btn btn-secondary"
                @click="$bvModal.hide('undefined-modal')"
                type="button"
              >
                Close
              </button>
              <button
                class="btn btn-primary"
                type="button"
                @click="confirmUndefined('undefined-modal')"
              >
                Save result
                <b-spinner
                  v-if="ResultReviewStatus"
                  variant="light"
                  small
                  role="status"
                ></b-spinner>
              </button>
            </div>
          </b-modal>

          <!-- ============================ -->
          <b-modal
            id="parameter-modal"
            ref="modal"
            size="xl"
            @hidden="resetParaModal"
            hide-footer
          >
            <template #modal-title>
              <p class="text-uppercase">
                {{ parameterResult.testName }} result reviewing.
              </p>
            </template>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Test</th>
                  <th>Result</th>
                  <th>Flag</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody v-if="parameterResult.parameters">
                <tr
                  v-for="(parameter, index) in parameterResult.parameters"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ parameter.parameterName }}</td>
                  <td>
                    <input
                      class="form-control"
                      list="suggestions"
                      id="suggestionsDataList"
                      @input="resetMsg"
                      v-model="parameter.result_value"
                      placeholder="Type new or search from existing results.."
                    />
                    <datalist id="suggestions">
                      <option
                        v-for="(suggest, s) in ResultSuggestions
                          ? ResultSuggestions
                          : []"
                        :key="s"
                        :value="suggest.result"
                      ></option>
                    </datalist>
                  </td>
                  <td>
                    <model-list-select
                      :list="flagOptions ? flagOptions : []"
                      v-model="parameter.result_flag"
                      option-value="value"
                      option-text="label"
                      placeholder="Select Result Interpretation"
                    >
                    </model-list-select>
                  </td>
                  <td>
                    <div class="form-group">
                      <textarea
                        class="form-control"
                        rows="3"
                        v-model="parameter.comment"
                      ></textarea>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="5">
                    <div style="text-align: center">
                      <h3 class="text-primary">
                        <b-spinner
                          class="m-0"
                          variant="primary"
                          role="status"
                        ></b-spinner>
                        Loading results please wait...
                      </h3>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-danger" v-if="this.noParameterFound">
              <em>{{ this.noParameterFound }}</em>
            </div>
            <div class="text-danger" v-if="this.dataRequired">
              <em>{{ this.dataRequired }}</em>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                @click="closeMode('parameter-modal')"
                class="btn btn-secondary"
              >
                Close
              </button>
              <button
                type="button"
                @click="confirmPara('parameter-modal')"
                class="btn btn-success"
              >
                Save result
                <b-spinner
                  v-if="ResultReviewStatus"
                  variant="light"
                  small
                  role="status"
                ></b-spinner>
              </button>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </Layout>
</template>
